module.exports = __webpack_public_path__ + "img/3.1328c351.jpg";